import { MotionReveal } from "../../components/MotionReveal";

export default function BfsiIndustryPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="pt-6 sm:pt-10">
        <MotionReveal>
          <div className="glass-panel rounded-3xl p-8 sm:p-10">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs uppercase tracking-[0.18em] text-[var(--text-secondary)]">
              BFSI
            </div>
            <h1 className="mt-6 font-[var(--font-display)] text-4xl sm:text-5xl tracking-tight text-white">
              BFSI AIOps & Observability
            </h1>
            <p className="mt-4 max-w-3xl text-sm sm:text-base text-[var(--text-secondary)]">
              Digital banking with zero-compromise reliability.
            </p>
            <div className="mt-8 grid gap-4 lg:grid-cols-2">
              <div className="rounded-3xl border border-white/10 bg-white/3 p-6">
                <div className="text-xs uppercase tracking-[0.22em] text-[var(--text-secondary)]">Challenge</div>
                <div className="mt-3 grid gap-2 text-sm text-[var(--text-secondary)]">
                  <div>99.99% uptime expectations</div>
                  <div>Milliseconds matter for transaction latency</div>
                  <div>PCI-DSS, SOX, RBI mandates</div>
                  <div>High cost of downtime</div>
                </div>
              </div>
              <div className="rounded-3xl border border-white/10 bg-white/3 p-6">
                <div className="text-xs uppercase tracking-[0.22em] text-[var(--text-secondary)]">Outcomes</div>
                <div className="mt-3 grid gap-2 text-sm text-[var(--text-secondary)]">
                  <div>✓ 40–70% lower MTTR</div>
                  <div>✓ Improved Customer experience scores</div>
                  <div>✓ Regulatory audit confidence</div>
                  <div>✓ Reduced operational costs</div>
                </div>
              </div>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center rounded-xl px-5 py-3 text-sm font-medium text-[#061019] bg-[var(--accent-primary)] hover:brightness-110"
              >
                Request BFSI Assessment
              </a>
              <a
                href="/capabilities"
                className="inline-flex items-center justify-center rounded-xl px-5 py-3 text-sm font-medium text-white border border-white/15 bg-white/5 hover:bg-white/8"
              >
                Explore Capabilities
              </a>
            </div>
          </div>
        </MotionReveal>
      </div>
      <div className="h-12" />
    </div>
  );
}
